import React, { useEffect, useState, useContext } from 'react';
import CheckField from '../../../../components/CheckField2/CheckField';
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from "../../../../../config/Configuration";
import TextField from '../../../../components/TextField/TextField';


function FacilityAdvancedEntry({ props, formik, dbFormSpec }) {
    let entryType = (props.type || "").toLowerCase().trim();

    switch (entryType) {
        case "textbox":
            return (
                <>< CheckField id={props.key} checkboxType={'facilityTextbox'} formik={formik} className={'advancedFacilityList'} formValue={props.key} checkItemLabel={props.value} trueFormSpec={dbFormSpec} tooltip={props.address} />
                    <TextField fieldType={'facility'} formik={formik} fieldId={props.fieldID} cssField={'fname-field'} label={
                        props.label ? props.label : "Please print provider's name."} maxLength={500} />
                </>


            );
        case "hr":
            return (<div>  <hr style={{ opacity: 0, marginBottom: 0 }} /><br /></div>);
        case "text": return (<>{props.value}</>);
        case "checkbox": // is the default.
        default: return (<> < CheckField id={props.key} checkboxType={'facility'} formik={formik} className={'advancedFacilityList'} formValue={props.key} checkItemLabel={props.value} trueFormSpec={dbFormSpec} tooltip={props.address} /></>);
    }
}


function FacilityAdvancedList({ formik, dbFormSpec }) {
    const facilityListFilled = dbFormSpec.release.facilities.map((props, index) =>
        <div className='facility-item' key={"facilitySelect" + index} > <FacilityAdvancedEntry props={props} formik={formik} dbFormSpec={dbFormSpec} /> </div>
    );
    return (
        <>
            {facilityListFilled}
        </>
    );
}

export default FacilityAdvancedList;
